export default {
  'primary-newsletter-button-cta-label': 'Subscribe to our newsletter',
}
